module.exports = __webpack_public_path__ + "img/wellness_assessment_black.ec3b0f03.svg";